var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReSendScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6C22 8.20914 20.2091 10 18 10C15.7909 10 14 8.20914 14 6C14 3.79086 15.7909 2 18 2C20.2091 2 22 3.79086 22 6ZM18 3.75C18.4142 3.75 18.75 4.08579 18.75 4.5V5.25H19.5C19.9142 5.25 20.25 5.58579 20.25 6C20.25 6.41421 19.9142 6.75 19.5 6.75H18C17.5858 6.75 17.25 6.41421 17.25 6V4.5C17.25 4.08579 17.5858 3.75 18 3.75ZM18 11.5V19C18 20.6569 16.6569 22 15 22H5C3.34315 22 2 20.6569 2 19V11C2 9.34315 3.34315 8 5 8H12.8749C13.675 10.0487 15.668 11.5 18 11.5ZM5.4 12.55C5.64853 12.2187 6.11863 12.1515 6.45 12.4L8.65 14.05C9.45 14.65 10.55 14.65 11.35 14.05L13.55 12.4C13.8814 12.1515 14.3515 12.2187 14.6 12.55C14.8485 12.8814 14.7814 13.3515 14.45 13.6L12.25 15.25C10.9167 16.25 9.08333 16.25 7.75 15.25L5.55 13.6C5.21863 13.3515 5.15147 12.8814 5.4 12.55Z",
    fill: "#6B7DE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReSendScheduleIcon);
export default __webpack_public_path__ + "static/media/RE_SendSchedule_icon.93f90a2bda5d2c3668fc3c2da87f722b.svg";
export { ForwardRef as ReactComponent };